'use strict';

import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import Person from './components/Person';
import UserForm from './components/UserForm';
import HpaContacts from './components/HpaContacts';
import { doGetFirstTimeHpa, doGetHpaContact } from './data/actions';
import { withPageBase } from '../../components/PageBase';
import { selectIsHpa } from '../../data/hpa/selectors';
import { USER, USERINFO } from '../../data/reducer';
import { updateUserInfo } from '../../data/user/profile/actions';
import { updateInboxStatus } from '../../data/user/officialServices/actions';
import { getUserInfoRequests } from '../../data/user/userInfoRequests/actions';
import ContactList from './components/contacts/ContactList';
import UpdateUserInfoNotification from './components/UpdateUserInfoNotification';
import HpaInfoNotification from './components/HpaInfoNotification';
import UserInfoRequests from './components/UserInfoRequests';
import UserInfoRequestsNotification from '../userInfoRequest/UserInfoRequestsNotification';
import { FEATURE_CONTACT, FEATURE_USERINFOREQUEST, isFeatureOn } from '../../definitions/Config';

const { id: module_id } = module;

const UserInfo = (props) => {
  const {
    isHpa,
    userInfo,
    hpaContact,
    updateUserInfo,
    doGetFirstTimeHpa,
    doGetHpaContact,
    updateInboxStatus,
    getUserInfoRequests,
    userInfoRequests,
  } = props;

  let contactFeatureOn = isFeatureOn(FEATURE_CONTACT);
  const [firstTimeHpaSession, setFirstTimeHpaSession] = useState(
    hpaContact.firstTimeHpaSession
  );
  const [showHpaContact, setShowHpaContact] = useState(true);

  useEffect(() => {
    checkisHpa();
    doGetHpaContact();
    hpaContactCheck();
    updateInboxStatus();
    getUserInfoRequests();
  }, []);

  useEffect(() => {
    setFirstTimeHpaSession(hpaContact.firstTimeHpaSession);
    hpaContactCheck();
  }, [hpaContact.firstTimeHpaSession]);

  const checkisHpa = () => {
    isHpa && doGetFirstTimeHpa();
  };

  const hpaContactCheck = () => {
    // check for when a hpa session is on behalf of a under 13 user
    const hpaUnder13 = isHpa && userInfo.age < 13;

    // check for when there has not been a hpa session for over 17 user
    const hpaOver17NoHpaSessions =
      userInfo.age > 17 && !userInfo.hasPreviousHpaSessions;

    if (!!hpaUnder13 || hpaOver17NoHpaSessions) {
      setShowHpaContact(false);
    }
  };

  return (
    <>
      <UpdateUserInfoNotification
        isHpa={isHpa}
        userInfo={userInfo}
        updateUserInfo={updateUserInfo}
        contactFeatureOn={contactFeatureOn}
      />
      <UserInfoRequestsNotification />
      {isHpa && firstTimeHpaSession && <HpaInfoNotification />}

      <Person person={userInfo} updateUserInfo={updateUserInfo} />
      <ContactList contactFeatureOn={contactFeatureOn} />
      <UserForm
        userFormId="userAgreement"
        formValues={{
          date: userInfo.eagreementAcceptanceDate,
          userAgreement: userInfo.agreement,
        }}
      />
      {showHpaContact && <HpaContacts isHpaSession={isHpa} />}
      {isHpa === false && isFeatureOn(FEATURE_USERINFOREQUEST) && (
        <UserInfoRequests requests={userInfoRequests.userInfoRequests} />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userInfo: state[USER].userInfo.data,
    hpaContact: state[USERINFO],
    contacts: state[USER].contacts,
    userInfoRequests: state[USER].userInfoRequests,
    isHpa: selectIsHpa(state),
  };
};

export default withPageBase(
  connect(mapStateToProps, {
    updateUserInfo,
    doGetFirstTimeHpa,
    doGetHpaContact,
    updateInboxStatus,
    getUserInfoRequests,
  })(UserInfo),
  { title: `${module_id}.title` }
);
